export const DraggableTypes = {
  FILE: 'file'
};